import { mapState } from 'vuex'

export default {
  name: 'DatePeriodPicker',
  props: ['value', 'disabled', 'allperiods', 'everySecond'],
  data () {
    return {
      content: this.value,
      searchTxt: '',
      displaySelectList: false
    };
  },
  computed: {
    ...mapState(['config']),
    datePeriodOptions () {
      if (this.config);
      const perConfig = (this.config ? this.config.datePeriodConfig : null);
      if (perConfig) {
        const options = [];
        let year = this.config.currentDatePeriod.year;
        let startPeriod = this.config.currentDatePeriod.period / 10;
        if (this.allperiods) {
          year = perConfig.endYear;
          startPeriod = perConfig.periodCount;
        }
        while (year >= perConfig.startYear) {
          for (let i = startPeriod; i > 0; i--) {
            if (!this.everySecond || (i % 2 === 1)) {
              options.push({ value: year + '0' + i + '0', text: this.$tc('general.datePeriod.short', i, { year: year, period: i }) });
            }
          }
          startPeriod = perConfig.periodCount;
          year -= 1;
        }
        return options;
      }
      return [];
    },
    filteredPeriods () {
      const self = this;
      return this.datePeriodOptions.filter(function (item) {
        return (item.text.indexOf(self.searchTxt) >= 0);
      });
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content);
      this.$emit('change', this.content);
    },
    selectItem (value) {
      const item = this.datePeriodOptions.find(el => el.value === value);
      this.searchTxt = item.text;
      this.content = item.value;
      this.displaySelectList = false;
      this.updateValue();
    },
    clearSearch () {
      this.searchTxt = '';
      this.content = null;
      this.displaySelectList = false;
      this.updateValue();
    },
    openFilterSel () {
      this.searchTxt = '';
      this.displaySelectList = true;
    }
  },
  mounted () {
    const datePerConf = this.BasicHelper.datePeriodCodeToData(this.content);
    this.searchTxt = (datePerConf ? this.$tc('general.datePeriod.short', datePerConf.period, datePerConf) : '');
  }
}
